import React, {
  Fragment,
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react'
// import MainContent from '../components/Layout/MainContent'
import MenuList from '../components/Layout/MenuList'

import { RouteI } from 'safe'
import { setUserAndToken } from '../redux/actions/authentication'
import { getRoutes } from '../routes'

import axios from 'axios'
import { AnimatePresence } from 'framer-motion'
import jwtDecode from 'jwt-decode'
import { DateTime } from 'luxon'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect, Route, Switch, useHistory } from 'react-router'
import Modal from '../components/Display/Modal'
import Button from '../components/General/Button'
import InputUpload from '../components/Inputs/InputUpload'
import Header, { HeaderProps } from '../components/Layout/Header'
import SubMenu from '../components/Layout/SubMenu'
import RolesPlansGuard from '../guards/RolesPlansGuard'
import useSnackBars from '../hooks/SnackbarConsumerHook'
import { fetchCategories } from '../redux/actions/categories'
import { fetchCurrencies } from '../redux/actions/currencies'
import { fetchRates } from '../redux/actions/rates'
import { fetchWarehouses } from '../redux/actions/warehouses'
import { RootState } from '../redux/store'
import { uploadDynamicFile } from '../utils/UploadFile'
import CloseFoodOrder from '../views/Restaurants/CloseFoodOrder'
import InvoiceSubscription from '../views/Suscribers/InvoiceSubscription'
import DashboardStats from './DashboardStats'
import StepRegistation from './StepRegistation'

const server = process.env.REACT_APP_SERVER_URL

// auth,
const Dashboard: React.FC<DashboardProps> = () => {
  const today = DateTime.local().setLocale('es')

  const [collapsed, setCollapsed] = useState<boolean>(true)

  const [dashboardRoutes, setDashboardRoutes] = useState<RouteI[]>([])
  const [route, setRoute] = useState<RouteI | undefined>(undefined)

  const [first, setfirst] = useState<any>(null)

  const [headerActions, setHeaderActions] =
    useState<HeaderProps['headerActions'] | null>(null)
  const [[page, direction], setPage] = useState([0, 0])
  const [animate, setAnimate] = useState<boolean>(false)
  const [selected, setSelected] = useState<number>(-1)
  const { addAlert } = useSnackBars()

  const [isKYCLoading, setIsKYCLoading] = useState<boolean>(false)

  const dispatch = useDispatch()

  const userRole = useSelector((state: RootState) => state?.auth?.user)

  const history = useHistory()

  const [showVerifyModal, setShowVerifyModal] = useState<boolean>(false)

  const [imageKYC, setImageKYC] = useState<any>(null)

  const getRoute = (e) => {
    setRoute(e)
  }

  const [selectedPage, setSelectedPage] = useState<number>(0)

  const [divElement, setDivElement] = useState<any>(null)

  const [isFirstRender, setIsFirstRender] = useState<boolean>(false)

  // const userRole = useSelector((state: RootState) => state.auth.user["custom:tenant_id"])

  // const iterate = (basePath: string, baseKey: number = 0, menu?: RouteI[]) => {
  //   let myKey = baseKey
  //   return menu
  //     ? menu.map((m) =>
  //       baseKey > 0 ? (
  //         <>
  //           <Route key={m.path} path={`${basePath}/${m.path}`} exact={m.exact}>
  //             <div className="flex flex-col flex-grow overflow-y-auto px-14 py-10">
  //               <m.component />
  //               {console.log(`${basePath}/${m.path}`)}
  //             </div>
  //           </Route>
  //           {m.subMenu
  //             ? iterate(`${basePath}/${m.path}`, ++myKey, m.subMenu)
  //             : null}
  //         </>
  //       ) : (
  //         iterate(`${basePath}/${m.path}`, ++myKey, m.subMenu)
  //       )
  //     )
  //     : null
  // }

  const swipeConfidenceThreshold = 10000
  const swipePower = (offset: number, velocity: number) => {
    return Math.abs(offset) * velocity
  }
  const paginate = (newDirection: number) => {
    setPage([page + newDirection, newDirection])
  }

  useEffect(() => {
    let prev
    if (dashboardRoutes.length > 0) {
      prev = dashboardRoutes.findIndex((r) =>
        history.location.pathname.includes(
          typeof r.path === 'string' ? r.path : r.path[0]
        )
      )
      return history.listen((location) => {
        let split = location.pathname.split('/')
        if (split.length === 3) {
          let curr = dashboardRoutes.findIndex((r) =>
            location.pathname.includes(
              typeof r.path === 'string' ? r.path : r.path[0]
            )
          )
          if (curr > prev) {
            paginate(1)
            setAnimate(true)
          } else if (curr < prev) {
            paginate(-1)
            setAnimate(true)
          }
          prev = curr
        } else setTimeout(() => setAnimate(false), 1)
      })
    }
    //eslint-disable-next-line
  }, [history, dashboardRoutes])

  const credentials = localStorage.getItem('credentials')
  useEffect(() => {
    if (credentials) {
      const parsedCredentials = JSON.parse(credentials)
      try {
        let user = jwtDecode(parsedCredentials.access_token)
        dispatch(setUserAndToken({ user }))
      } catch {
        localStorage.removeItem('credentials')
        history.push('/ingresar')
      }
    } else {
      history.push('/ingresar')
    }
    //eslint-disable-next-line
  }, [credentials])

  const getMultipleValues = async () => {
    let [categories, currencies, warehouses, rates] = await Promise.all([
      fetchCategories(),
      fetchCurrencies(),
      fetchWarehouses(),
      fetchRates([`date=${today.toISODate()}`, `currency=${'all'}`]),
    ])
    dispatch(categories)
    dispatch(currencies)
    dispatch(warehouses)
    dispatch(rates)
  }

  useEffect(() => {
    getMultipleValues()
    // dispatch(fetchCategories())
    // dispatch(fetchCurrencies())
    // dispatch(fetchWarehouses())
    // dispatch(fetchUnits())
    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (userRole) {
      setDashboardRoutes(
        getRoutes(userRole['custom:user_role'], userRole['custom:user_plan'])
      )
    }
  }, [userRole])

  useLayoutEffect(() => {
    // if (userRole && userRole['custom:user_plan'] !== 'estudiantil') {
    // const script = document.createElement('script')
    // script.src = '//fw-cdn.com/3288666/3113011.js'
    // script.setAttribute('chat', 'true')
    // script.onload = () => {
    //   setTimeout(() => {
    //     let widget = document.getElementById("fc_widget")
    //     console.log("llega listo...", widget)
    //   }, 4000)
    // }
    // document.head.appendChild(script)
    // setTimeout(() => {
    //   let widget = document.getElementById("fc_widget")
    //   console.log("LLEGA", widget)
    //   if (widget) {
    //     widget.style.display = 'none'
    //   }
    // }, 2000)
  }, [userRole])

  // useEffect(() => {
  //   setTimeout(() => {
  //     dispatch(changeFirstTime())
  //   }, 5000)
  // }, [])

  useLayoutEffect(() => {
    let mytimer = setInterval(() => {
      let widget = document.getElementById('fc_widget')
      if (widget) {
        clearInterval(mytimer)
        setDivElement(widget)
      }
    }, 500)
  }, [divElement])

  useEffect(() => {
    if (divElement) {
      if (userRole && userRole['custom:user_plan'] !== 'estudiantil') {
        divElement.style.display = 'inherit'
      } else {
        divElement.style.display = 'none'
      }
    }
  }, [userRole, divElement])

  const [windowSize, setWindowSize] = useState(getWindowSize())

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }

  const DashboardStatsRedirect = useCallback(() => {
    if (userRole && userRole['custom:user_role'] === 'waiter') {
      return <Redirect to="/dashboard/restaurantes/mesas" />
    }
    return (
      <DashboardStats
        isFirstRender={isFirstRender}
        setIsFirstRender={setIsFirstRender}
      />
    )
  }, [userRole])

  useEffect(() => {
    // setShowVerifyModal(true)
    // setInterval(() => {
    //   onVerifyKYC()
    // }, 100)
  }, [])

  const onSubmitKYC = async () => {
    try {
      setIsKYCLoading(true)
      await uploadDynamicFile(
        imageKYC,
        `${userRole['custom:tenant_id']}/kyc_id.jpeg`,
        process.env.REACT_APP_S3_URL_DOCS
      )

      let resp = await axios.post(`${server}/kyc`, {})

      if (resp?.data?.is_valid) {
        await axios.patch(`${server}/user/tenant`, {
          isKyc: true,
        })

        setShowVerifyModal(false)
        addAlert({
          message: 'Documento validado correctamente',
          status: 'success',
        })
      } else {
        addAlert({
          message:
            'El documento que subiste, no es un documento de identidad válido, debe de ser un RIF o CI vigente',
          status: 'error',
          duration: 8000,
        })
      }
    } catch (err: any) {
      addAlert({
        message:
          'En este momento tenemos problemas para la validación, comunicate con soporte',
        status: 'error',
      })
    } finally {
      setIsKYCLoading(false)
    }
  }

  const onGetUserKYC = async () => {
    try {
      const response = await axios.get(`${server}/user/tenant`)
      console.log('response', response)
      const dateSigned = new Date(response?.data?.tenant?.dateSigned)
      const today = new Date()
      const diffTime = Math.abs(today.getTime() - dateSigned.getTime())
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      console.log('KYC', response?.data?.isKyc)
      console.log('KYC RESPONSE', response?.data?.tenant)

      if (
        !response?.data?.tenant?.isKyc &&
        userRole &&
        userRole['custom:first_time'] !== 'true' &&
        diffDays > 7
      ) {
        console.log('showVerifyModal')
        setShowVerifyModal(true)
      }
    } catch (err) {
      console.log('error', err)
    }
  }

  useEffect(() => {
    onGetUserKYC()
  }, [userRole])

  return (
    <div className="w-full h-screen flex flex-nowrap dark:bg-primaryGray-dark">
      <MenuList
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        routes={dashboardRoutes}
        getRoute={getRoute}
        urlIndex={1}
        selected={selected}
        setSelected={setSelected}
      />
      {/* <MainContent routes={dashboardRoutes} activeRoute={route} /> */}

      <div className="w-full overflow-auto h-screen flex flex-col lg:ml-20">
        <div className="flex flex-nowrap">
          <Header
            setCollapsed={setCollapsed}
            title={
              route?.subMenu && route?.subMenu?.length === 1
                ? route?.subMenu[0].title
                : route?.title
            }
            headerActions={headerActions}
          />
        </div>
        {route?.subMenu && route.subMenu.length > 1 && (
          <SubMenu
            routes={
              route.subMenu.filter((subMenu) => !subMenu.disabledRole) || []
            }
            basePath={`/dashboard/${route.path}`}
            urlIndex={2}
          />
        )}
        <div className="m-5 lg:m-10">
          {/* <Modal display={userRole && userRole['custom:first_time'] === 'true'} onClose={() => {}} hideClose={true}> */}
          <Modal
            display={userRole && userRole['custom:first_time'] === 'true'}
            // display={true}
            onClose={() => {}}
            hideClose={true}
            // contentStyle={{overflow: 'visible'}}
            xlClasses={
              selectedPage === 0
                ? `w-1/3`
                : windowSize.innerWidth < 1200
                ? 'w-2/3'
                : ''
            }
          >
            <div className="relative overflow-visible">
              <StepRegistation onClick={setSelectedPage} />
            </div>
            {/* <div>
              <Button onClick={() => {
                dispatch(changeFirstTime())
              }}>Boton de prueba</Button>
            </div> */}
          </Modal>

          <Modal display={showVerifyModal} onClose={() => {}} hideClose={true}>
            <div>
              <h1 className="font-bold text-2xl text-coolGray-900 mb-2 dark:text-white col-span-12">
                Tu plazo para la verificación de identidad ha expirado
              </h1>
              <p className="font-normal text-gray-400 text-sm mb-2 col-span-12">
                Lamentablemente, el período de 7 días para completar la
                verificación de tu identidad (KYC) ha terminado. Para seguir
                utilizando todas las funciones de tu cuenta, es indispensable
                que subas los documentos necesarios para la verificación.
              </p>{' '}
            </div>

            <div className="mt-5 flex flex-col items-center">
              <InputUpload
                isCompressed={true}
                title="Sube el documento"
                fileType="image"
                handleImage={(img) => {
                  setImageKYC(img)
                }}
                deleteImage={() => {
                  setImageKYC(null)
                }}
                // containerClasses="xl:col-start-1 xl:row-span-3 xl:col-span-3 col-start-3 col-span-8 row-span-8 m-auto"
                imageClasses="rounded-md dark:border-gray-700"
                maxHeight="max-h-[250px]"
                size={6000000}
              />

              <div className="mt-5 flex flex-row items-center justify-center w-full">
                <Button
                  type="primary"
                  loading={isKYCLoading}
                  disabled={isKYCLoading}
                  onClick={() => {
                    onSubmitKYC()
                  }}
                >
                  Verificar
                </Button>
              </div>
            </div>
          </Modal>
          {/* <div className="overflow-auto m-5 lg:m-10 pb-48"> */}
          <Switch>
            <Fragment>
              {history.location.pathname === '/dashboard/dashboard/init' ? (
                <DashboardStatsRedirect />
              ) : (
                dashboardRoutes.map((obj) => (
                  <Fragment key={obj.path}>
                    <AnimatePresence initial={false} custom={direction}>
                      {obj.subMenu &&
                        obj.subMenu.map((obj2) => (
                          <RolesPlansGuard
                            key={obj2.path}
                            // path={`/dashboard/${obj.path}/${obj2.path}`}
                            exact={obj2.exact}
                            component={obj2.component}
                            setHeaderActions={setHeaderActions}
                            path1={obj.path}
                            path2={obj2.path}
                            selected={selected}
                            setSelected={setSelected}
                          />
                        ))}
                      {/* {iterate(`/dashboard/${obj.path}`, 0, obj.subMenu)} */}
                      <Route
                        key={obj.path}
                        path={`/dashboard/${obj.path}`}
                        exact={true}
                      >
                        <Redirect
                          to={
                            obj.subMenu
                              ? `/dashboard/${obj.path}/${
                                  obj.subMenu.find((sub) => !sub.disabledRole)
                                    ?.path || obj.subMenu[0].path
                                }`
                              : '/'
                          }
                        />
                      </Route>
                    </AnimatePresence>
                  </Fragment>
                ))
              )}
            </Fragment>
          </Switch>
          <Route
            path={`/dashboard/restaurantes/cerrar-comanda`}
            render={(props) => <CloseFoodOrder />}
            exact={true}
          />
          <Route
            path={`/dashboard/suscripcion/facturar`}
            render={(props) => <InvoiceSubscription />}
            exact={true}
          />
        </div>
      </div>
    </div>
  )
}

export default Dashboard

interface DashboardProps {}
